// This uses tailwind colors to generate a background color + text color.
// See options here: https://tailwindcss.com/docs/customizing-colors
export const COLORS = {
  red: 'bg-red-100 text-red-900',
  orange: 'bg-orange-100 text-orange-900',
  amber: 'bg-amber-100 text-amber-900',
  yellow: 'bg-yellow-100 text-yellow-900',
  lime: 'bg-lime-100 text-lime-900',
  green: 'bg-green-100 text-green-900',
  emerald: 'bg-emerald-100 text-emerald-900',
  teal: 'bg-teal-100 text-teal-900',
  cyan: 'bg-cyan-100 text-cyan-900',
  sky: 'bg-sky-100 text-sky-900',
  blue: 'bg-blue-100 text-blue-900',
  indigo: 'bg-indigo-100 text-indigo-900',
  violet: 'bg-violet-100 text-violet-900',
  purple: 'bg-purple-100 text-purple-900',
  fuchsia: 'bg-fuchsia-100 text-fuchsia-900',
  pink: 'bg-pink-100 text-pink-900',
  rose: 'bg-rose-100 text-rose-900',
  gray: 'bg-gray-100 text-gray-900',
  slate: 'bg-slate-100 text-slate-900',
};
